const Footer = () => (
  <footer className="footer-area text-white">
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <p>
            Copyright &copy;&nbsp;
            {new Date().getFullYear()}
          </p>
        </div>
        <div className="col-md-6">
          <div className="d-flex justify-content-end">
            <ul>
              <li>
                <a href="mailto: sales@matlogica.com">
                  sales@matlogica.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;